import React from 'react';

interface LogoProps {
	width: number;
	height: number;
	src: string;
}

const Logo: React.FC<LogoProps> = ({ width, height, src }) => {
	return <img src={src} alt="finclu-logo" width={width} height={height} />;
};

export default Logo;
